import { UNIT_TYPES } from '@bienenkampf/shared';
/** mindest_hofstaat = 800 + zielpunkte * 0.35 (freier Platz: zielpunkte 0). */
export function minCourt(balance, targetPoints) {
    const c = balance.colonize;
    return Math.ceil(c.minCourtBase + Math.max(0, targetPoints) * c.minCourtPerTargetPoint);
}
/**
 * Konzept 6, Kolonisation:
 *   verlust = hofstaat * 0.30 * colonize_loss_mult(saison) * (1 + restbevoelkerung/1000 + 0.1 * waechterwabe)
 *   ueberlebende < mindest_hofstaat -> scheitert (Koenigin stirbt, Rest kehrt heim)
 * Die Verlustrate ist auf 1 gedeckelt; Verluste je Typ gerundet.
 */
export function resolveColonize(balance, court, mods) {
    const c = balance.colonize;
    const factor = 1 + mods.remainingPop * c.lossPerRemainingPop + mods.guardCombLevel * c.lossPerGuardCombLevel;
    const lossRate = Math.min(1, Math.max(0, c.baseLossRate * mods.seasonLossMult * factor));
    const losses = {};
    const survivors = {};
    let survivorCount = 0;
    for (const t of UNIT_TYPES) {
        const n = court[t] ?? 0;
        if (n <= 0)
            continue;
        const lost = Math.min(n, Math.round(n * lossRate));
        if (lost > 0)
            losses[t] = lost;
        if (n - lost > 0)
            survivors[t] = n - lost;
        survivorCount += n - lost;
    }
    const required = minCourt(balance, mods.targetPoints);
    return {
        lossRate,
        losses,
        survivors,
        survivorCount,
        required,
        success: survivorCount >= required,
    };
}
/** Wabenstufen nach Uebernahme: halbiert, abgerundet (Konzept). */
export function halveLevels(levels) {
    const out = {};
    for (const k of Object.keys(levels))
        out[k] = Math.floor((levels[k] ?? 0) / 2);
    return out;
}
//# sourceMappingURL=colonize.js.map